import { useState } from 'react'

import { Alert, Box, Snackbar } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'

import { SignupDialog as ConfirmationDialog } from './confirmationDialog'
import { FormWidget as SignupForm } from './signupForm'
import { useProject, useWidgetConfig } from '../../api/widget'

export const FormWidget = () => {
  const { t } = useTranslation()
  const { projectId } = useParams()
  const location = useLocation()

  const [openConfirmation, setOpenConfirmation] = useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false)

  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')
  const propertyId = searchParams.get('propertyId')

  const { data: project, error: projectError } = useProject(projectId, token)
  const {
    data: widgetConfig,
    isLoading,
    error: configError,
  } = useWidgetConfig(projectId, token)

  const error = projectError || configError

  const handleSuccessSignup = () => {
    const redirectUrl = widgetConfig?.widgetRedirectUrl ?? ''
    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      setOpenConfirmation(true)
    }
  }

  const handleErrorSignup = () => {
    setOpenSnackbar(true)
  }

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false)
  }

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false)
  }

  const hasTokenError = !token || error?.status === 401 || error?.status === 403

  if (hasTokenError) {
    return (
      <Alert severity="error">
        {t('Token is missing or invalid, please check the widget settings.')}
      </Alert>
    )
  }

  if (error) {
    return <Alert severity="error">{t('Something went wrong')}</Alert>
  }

  if (isLoading) {
    return null
  }

  return (
    <Box sx={{ p: 1 }}>
      <SignupForm
        projectId={projectId}
        propertyId={propertyId}
        privacyPolicyHtml={widgetConfig?.privacyPolicyCheckboxLabelHtml}
        onSuccess={handleSuccessSignup}
        onError={handleErrorSignup}
        token={token}
        isOrganization={project?.allowedBuyers?.[0] === 'COMPANY'}
      />
      <ConfirmationDialog
        open={openConfirmation}
        onClose={handleCloseConfirmation}
      />
      <Snackbar
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        message={t('Something went wrong')}
      />
    </Box>
  )
}
